import React from "react";
import "./NeedAssessComponent.css";

function NeedAssessComponent({ icon, heading, content }) {
  return (
    <div>
      <div
        style={{
          display: "flex",
          gap: "12px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#A2C357",
            // margin: "2px 3% 0 0",
            borderRadius: "100%",
            padding: "8px",
            background: "#F4F8EB",
            height: "fit-content",
          }}
        >
          {icon}
        </div>
        <div>
          <div className="need-assess-heading">{heading}</div>
          <div className="need-assess-content">{content}</div>
        </div>
      </div>
    </div>
  );
}

export default NeedAssessComponent;
